import React from "react";
import { useTranslation } from "react-i18next";

const socialLinks = [
  {
    name: "Instagram",
    href: "https://www.instagram.com/puertoricoesportsleague",
    icon: "/icon-instagram-clean.svg",
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/puertoricoesportsleague",
    icon: "/icon-facebook-clean.svg",
  },
  {
    name: "X",
    href: "https://x.com/presportsleague",
    icon: "/icon-x-clean.svg",
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@puertoricoesportsleague",
    icon: "/icon-youtube-clean.svg",
  },
];

export default function SiteFooter() {
  const { i18n } = useTranslation();
  const lang = i18n.language === "en" ? "en" : "es";
  const copy = lang === "en"
    ? {
        copyright: "All rights reserved.",
        press: "Press",
        privacy: "Privacy",
        terms: "Terms",
      }
    : {
        copyright: "Todos los derechos reservados.",
        press: "Prensa",
        privacy: "Privacidad",
        terms: "Términos",
      };

  return (
    <footer className="border-t border-white/10 py-10 px-6">
      <div className="max-w-[1500px] mx-auto flex flex-col md:flex-row justify-between items-center gap-6 text-slate-400 text-sm">
        <div className="flex items-center gap-2">
          <img src="/logo.png" alt="PR Esports League" className="h-7 opacity-90" />
          <p>© {new Date().getFullYear()} Puerto Rico Esports League. {copy.copyright}</p>
        </div>

        <div className="flex items-center gap-3">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.name}
              className="w-10 h-10 rounded-full border border-white/10 bg-white/5 hover:bg-white/10 transition flex items-center justify-center"
            >
              <img src={social.icon} alt={social.name} className="w-5 h-5 object-contain" />
            </a>
          ))}
        </div>

        <div className="flex gap-4 flex-wrap justify-center">
          <a href="/press" className="hover:text-white">{copy.press}</a>
          <a href="/privacidad" className="hover:text-white">{copy.privacy}</a>
          <a href="/terminos" className="hover:text-white">{copy.terms}</a>
        </div>
      </div>
    </footer>
  );
}
